<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Di Subcont Delivery Card" active>

                                <b-row v-if="hasFailedDataDiSubcontDeliveryCard">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDiSubcontDeliveryCard.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="diSubcontDeliveryCardsFailed" :fields="fieldsDiSubcontDeliveryCard" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDiSubcontDeliveryCard" :sort-desc.sync="sortDescDiSubcontDeliveryCard" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(dcQty)="row">
													{{ Number(row.item.dcQty).toLocaleString() }}
												</template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(sequence)="row">
													{{ Number(row.item.sequence).toLocaleString() }}
												</template>
												<template #cell(totalDeliveryCard)="row">
													{{ Number(row.item.totalDeliveryCard).toLocaleString() }}
												</template>
												<template #cell(transactionId)="row">
													{{ Number(row.item.transactionId).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDiSubcontDeliveryCard.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="diSubcontDeliveryCards" :fields="fieldsDiSubcontDeliveryCard" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDiSubcontDeliveryCard" :sort-desc.sync="sortDescDiSubcontDeliveryCard" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(dcQty)="row">
													{{ Number(row.item.dcQty).toLocaleString() }}
												</template>
												<template #cell(deliveryDate)="row">
													{{ row.item.deliveryDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(sequence)="row">
													{{ Number(row.item.sequence).toLocaleString() }}
												</template>
												<template #cell(totalDeliveryCard)="row">
													{{ Number(row.item.totalDeliveryCard).toLocaleString() }}
												</template>
												<template #cell(transactionId)="row">
													{{ Number(row.item.transactionId).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import DiSubcontDeliveryCard from '@/models/DiSubcontDeliveryCard/DiSubcontDeliveryCard';
import DiSubcontDeliveryCardList from '@/models/DiSubcontDeliveryCard/DiSubcontDeliveryCardList';
import DiSubcontDeliveryCardFilter from '@/filters/DiSubcontDeliveryCard/DiSubcontDeliveryCardFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsDiSubcontDeliveryCard: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "DC Qty", key: 'dcQty', sortable: false},
				{"class" : "th-status", "label" : "DI Subcont Detail", key: 'deliveryInstructionSubcontractDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Delivery Date", key: 'deliveryDate', sortable: false},
				{"class" : "th-status", "label" : "Sequence", key: 'sequence', sortable: false},
				{"class" : "th-status", "label" : "Total DeliveryCard", key: 'totalDeliveryCard', sortable: false},
				{"class" : "th-status", "label" : "Transaction Type", key: 'transactionType', sortable: false},
				{"class" : "th-status", "label" : "Transaction Id", key: 'transactionId', sortable: false},
				{"class" : "th-status", "label" : "Is Used", key: 'isUsed', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			diSubcontDeliveryCards : [],
			diSubcontDeliveryCardsFailed: [],
			diSubcontDeliveryCardId : '',
			sortByDiSubcontDeliveryCard: '',
			sortDescDiSubcontDeliveryCard: '',
			hasFailedDataDiSubcontDeliveryCard: false,
			totalFailedDiSubcontDeliveryCard: 0,
			totalSucceedDiSubcontDeliveryCard: 0,

			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('disubcontdeliverycard/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('disubcontdeliverycard/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getDiSubcontDeliveryCardForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getDiSubcontDeliveryCardForUpload : async function() {
			let _this = this;
			this.$http.get('disubcontdeliverycard/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.diSubcontDeliveryCards = [];


					if (response != null) {
						let result = response.data;
						_this.diSubcontDeliveryCards = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedDiSubcontDeliveryCard = _this.diSubcontDeliveryCards.length;

						_this.diSubcontDeliveryCardsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataDiSubcontDeliveryCard = true;
						_this.totalFailedDiSubcontDeliveryCard = 0;
						if(_this.diSubcontDeliveryCardsFailed == undefined || _this.diSubcontDeliveryCardsFailed.length === 0) _this.hasFailedDataDiSubcontDeliveryCard = false;
						if(_this.hasFailedDataDiSubcontDeliveryCard) _this.totalFailedDiSubcontDeliveryCard = _this.diSubcontDeliveryCardsFailed.length;

						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'disubcontdeliverycard/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'DiSubcontDeliveryCard.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterDiSubcontDeliveryCard = new DiSubcontDeliveryCardFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
